import { useArrived } from './Tooltip'

// How much of a statutory window has gone: a 6px stroke round a 52px circle,
// full and critical once the deadline has passed.

const R = 21
const C = 2 * Math.PI * R

export function ClockRing({ elapsed, color }: { elapsed: number; color: string }) {
  const arrived = useArrived()
  const share = Math.max(0, Math.min(1, elapsed))
  return (
    <svg className="hc-clock" viewBox="0 0 52 52" aria-hidden="true">
      <circle className="tr" cx="26" cy="26" r={R} />
      <circle
        className="fl"
        cx="26"
        cy="26"
        r={R}
        strokeDasharray={C}
        style={{ stroke: color, strokeDashoffset: arrived ? C * (1 - share) : C }}
      />
    </svg>
  )
}
